module.exports = __webpack_public_path__ + "static/img/loading.217440d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ui/loading.gif
// module id = IZEA
// module chunks = 1